import React, { useEffect } from 'react';
import { SectionSelectionComponent } from '@marty-js/design/src/molecules/section-selection';
import type { ItemSidebarComponentSectionSelectionType } from '../types';

const SectionSelection: React.FC<ItemSidebarComponentSectionSelectionType> = ({ data, setIsIamSticky }) => {
  useEffect(() => {
    setIsIamSticky?.(false);
  }, [setIsIamSticky]);

  const { title } = data.info;
  const { sections } = data.sections;

  return <SectionSelectionComponent title={title} sections={sections} />;
};

export default SectionSelection;
